// Google Ads — Customisation campaign config
// Traffic: people searching "build your own chocolate box", "personalised chocolate gift", etc.
// Mindset: warm, knows they want to customise. Lead with outcome and the building experience.

window.adConfigs = window.adConfigs || {};

window.adConfigs['google-customisation'] = {
  subtitle: 'The choice is yours',
  socialProof: '★★★★★ Loved picking my own flavours',
  carousel: [
    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Self_Treat_Caramel.png?v=1776269836',
    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Craving_Raspberry_3.png?v=1776243690',
    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Hand_held_bar_with_logo_for_scale_carousel.png?v=1777448524',
    'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Barnaby_10thDec-5274_Brighter_Shadow.png?v=1774431167',
  ]
};